import { injectDeps } from 'components-di';
import { Controller } from 'session-controller';
import ErrorView from 'views/Error';

import actions from './actions';

const TYPE = 'ERROR';

export default class ErrorController extends Controller {
  constructor(context) {
    super(context);
    this.view = injectDeps(context, actions)(ErrorView);
  }
  get name() {
    return 'ErrorController';
  }
  controllerWillMount(payload) {
    console.log(payload);
    const initialState = {};
    switch (payload && payload.type) {
      case 'PhaseNotActive':
        Object.assign(initialState, {
          header: '',
          subMessage: 'Try contacting the owner of the form if you think this is a mistake.',
        });
        break;
      default:
        Object.assign(initialState, {
          subMessage: 'Try contacting the owner of the form.',
        });
    }

    this.context.store.resetState(Object.assign({}, payload, initialState));
  }
  dispose() {}
  get type() {
    return TYPE;
  }
}



// WEBPACK FOOTER //
// ./src/controllers/ErrorController/index.js